import { ws } from "../../../utils/common";

export const getFavourtieAssociationsWS = async ({ favourite = true }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "association/info/",
    { favourite },
    null,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};

export const getNearAssociationsWS = async ({ limit = 8 }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "association/near/",
    { limit },
    null,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};

export const insertFavouriteAssociationWS = async (id_association) => {
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "favourite-association/",
    null,
    { id_association },
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};

export const deleteFavouriteAssociationWS = async (id_association) => {
  const res = await ws(
    "DELETE",
    process.env.REACT_APP_ENDPOINT + "favourite-association/" + id_association,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};
